import { convertToStoryblokCdn } from '../pipes/storyblok-cdn.pipe';

export const convertToOgImageUrl = (imageUrl: string, storyblokUrl: string): string => {
  if (!imageUrl) return;
  if (!imageUrl.includes(storyblokUrl)) return imageUrl;
  imageUrl = convertToStoryblokCdn(imageUrl, storyblokUrl);
  if (imageUrl.endsWith('.svg')) {
    return `${imageUrl}/m/1200x0/filters:format(jpg)`;
  }
  return `${imageUrl}/m/1200x0`;
};
